var _style, _g, _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVin2Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232 72",
    style: {
      enableBackground: "new 0 0 232 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F9BF2C;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#F9BF2C;}\n\t.st4{font-family:'Poppins-Medium';}\n\t.st5{font-size:24px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,32.8l9.9,26.4l9.8-26.4h5.4L21,65.4h-4.9L3.3,32.8H8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.2,65.4V32.8h5.2v32.7L39.2,65.4L39.2,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.3,42.3v23.1h-5.2V32.8h4.2l18.5,23.6V32.8H81v32.6h-4.5L58.3,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.2,59.8v5.6H89.4l2-2c4.1-4.1,7.3-7.4,9.5-9.9c2.3-2.5,4.2-5.1,5.7-7.7s2.3-5,2.3-7.3 c0-2.4-0.7-4.3-2.2-5.6c-1.4-1.3-3.2-1.9-5.3-1.9c-1.6,0-3,0.3-4.1,1c-1.1,0.7-1.9,1.5-2.4,2.6s-0.8,2.1-0.8,3.1 c0,2.6,0.8,4.7,2.3,6.3L93,47.3c-1.3-0.8-2.4-2.2-3.2-4c-0.8-1.9-1.2-3.7-1.2-5.4c0-2.2,0.6-4.2,1.7-6.1s2.7-3.4,4.8-4.6 c2.1-1.1,4.6-1.7,7.4-1.7c2.4,0,4.6,0.6,6.5,1.7s3.4,2.7,4.4,4.6s1.6,4,1.6,6.3s-0.5,4.6-1.6,6.8s-2.4,4.4-4,6.4s-3.7,4.5-6.3,7.4 l-0.9,1L116.2,59.8L116.2,59.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119,26c-7.6-3.9-15.3-6.8-23.2-9.1c-14.2,8.8-27.9-1.7-48.4-0.4c1.9-1.4,7.4-4.6,9.4-4.6 c12.4,0,23.9,1.4,34.2,5.9C62.1-1.5,23.1,17.2,3,22.2c60-10,71.1,7.4,93-1.3C103.6,21.3,111.3,23.5,119,26L119,26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.1,25.3l5.6,2.8c14-3.7,13.7-3.3,25.2-3.9C26.6,22.7,16.3,23,6.1,25.3L6.1,25.3z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 121 65.6898)",
    className: "st0 st4 st5"
  }, "Software")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVin2Logo);
export default __webpack_public_path__ + "static/media/vin2_logo.df4af0fb596faf4ce461b08ec4ac86ce.svg";
export { ForwardRef as ReactComponent };